var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDescIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6.583,
    height: 10.792,
    viewBox: "0 0 6.583 10.792",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6436",
    "data-name": "Path 6436",
    d: "M8.65,3.35,5.86,6.14a.5.5,0,0,0,.35.85H8V13a1,1,0,0,0,2,0V6.99h1.79a.5.5,0,0,0,.35-.85L9.35,3.35a.5.5,0,0,0-.7,0Z",
    transform: "translate(12.292 14) rotate(180)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescIcon);
export default __webpack_public_path__ + "static/media/descIcon.9a8d6f2e211038e02368048fda27aadc.svg";
export { ForwardRef as ReactComponent };